import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as images from "../../constants/Images";
import PropTypes from "prop-types";

import "./MiniSidebar.css";
import Avatar from "react-avatar";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function MiniSidebar(props) {
  const { activeLink } = props;
  const [dp, setdp] = useState("");
  const [empName, setName] = useState("");

  useEffect(() => getDetails(), []);

  const getDetails = async () => {
    let dp = await getFromEncLocalStorage("profile_pic");
    let firstName = await getFromEncLocalStorage("firstname");
    let lastName = await getFromEncLocalStorage("lastname");
    let name = firstName + " " + lastName;

    setdp(dp);
    setName(name);
  };

  return (
    <nav className="mini-sidebar">
      {dp ? (
        <img src={dp} alt="Profile pic" className="profile-img" />
      ) : (
        <Avatar
          name={empName}
          size="50px"
          round={true}
          style={{ marginTop: "30px" }}
        />
      )}
      <div className="minisidebar-menu">
        <Link
          to="/questions-answered-by-me"
          id={activeLink == "que_ans_by_me" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img
            src={images.sb1}
            className="menu-img"
            alt="Questions answered by me"
          />
        </Link>
        <Link
          to="/questions-asked-by-me"
          id={activeLink == "que_by_me" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img
            src={images.sb1}
            className="menu-img"
            alt="Questions asked by me"
          />
        </Link>
        <Link
          to="/knowledge-created-by-me"
          id={
            activeLink == "knowledge_by_me" ? "minisidebar-active-item" : null
          }
          className="minisidebar-menuitem"
        >
          <img
            src={images.sb2}
            className="menu-img"
            alt="Knowledge created by me"
          />
        </Link>
        <Link
          to="/bookmarks"
          id={activeLink == "bookmarks" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img src={images.sb4} className="menu-img-bookmark" alt="Bookmarks" />
        </Link>
        <Link
          to="/usefull-links"
          id={activeLink == "usefull_links" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img src={images.sb5} className="menu-img" alt="Usefull links" />
        </Link>
        <Link
          to="/guidelines-master"
          id={activeLink == "guidelines_master" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img src={images.sb5} className="menu-img" alt="Guidelines" />
        </Link>
        <Link
          to="/eventgallery"
          id={activeLink == "eventgallery" ? "minisidebar-active-item" : null}
          className="minisidebar-menuitem"
        >
          <img src={images.gallery_sb} className="menu-img" alt="Events Gallery" />
        </Link>
      </div>
    </nav>
  );
}

export default MiniSidebar;

MiniSidebar.propTypes = {
  activeLink: PropTypes.string,
};
